module.exports = __webpack_public_path__ + "img/youtube.d71941cb.svg";